import React, {
    useState,
    useEffect,
    useMemo,
    useCallback,
    forwardRef,
    useImperativeHandle,
    useRef
} from "react";
import {
    TextBox,
    Select,
    Checkbox
} from "@veneer/core";
import { Row, Col } from "react-bootstrap";
import type { RootState } from '@store/store';
import { useAppSelector, useAppDispatch } from '@store/hooks';
import { useTranslation } from "react-i18next";
import { setFormAlternateValidity } from '@store/reducers/form-contact-alternate-slice';
import { alternateContactInformation, alternateFormDetails } from '@constants/case-create';

import {
    getFieldError,
    getValidatedNumberInput,
    isValidEmail,
    isValidField,
    isValidPhoneNumber,
    onSearchDropDown,
    scrollToErrorField,
    validateFields,
    validateName,
} from "../../../../utils";
import { fetchContactDetails } from "@services/fetch-contact-details-info";
import { HelpModalPopup } from "@components/home-page/shared-components/modal-popup/help-modal-popup";


type MyComponentProps = {
    headerTitle?: string;
    headerContent?: string;
    checkBoxContent?: string
};

export interface PhysicalAddressFieldsRef {
    submitForm: () => boolean;
}

type AlternateContactInformation = typeof alternateContactInformation;

const CaseAlternateAddress = forwardRef<PhysicalAddressFieldsRef, MyComponentProps>(
    ({ headerTitle, headerContent }, ref) => {
        const dispatch = useAppDispatch()

        const { savedContactsDropDown, countryCodes, countryList } = useAppSelector((state: RootState) => state.createCaseAPI);
        const formAlternateData = useAppSelector((state) => state.formContactAlternateInfo.formAlternateData);

        const [formDetails, setFormDetails] = useState<AlternateContactInformation>(formAlternateData);
        const [errors, setErrors] = useState<AlternateContactInformation>(alternateContactInformation);

        const [formTouched, setFormTouched] = useState(true);
        const [filteredCountryCodeList, setFilteredCountryCodeList] = useState(countryCodes || []);
        const [filteredAltCountryCodeList, setFilteredAltCountryCodeList] = useState(countryCodes || []);
        const [filteredCountryList, setFilteredCountryList] = useState(countryList || []);
        const [popupTilte, setPopupTitle] = useState<string>("");
        const [open, setOpen] = useState(false);
        const [clear, setClear] = useState(false);
        const [isDisabled, setIsDisabled] = useState<boolean>(false);
        const [flgBrazil, setflgBrazil] = useState({
            neighbourhood: true,
            stateInscription: true,
            cpf: true
        });
        const [filteredAltContacts, setFilteredAltContacts] = useState();
        const { t } = useTranslation();

        //const defaultRequiredFields = ["FirstName", "LastName", "countryId", "PhoneNumber", "Email"];
        const requiredFields = ["FirstName", "LastName", "countryId", "PhoneNumber", "Email"];
        const [defaultRequiredFields, setDefaultRequiredFields] = useState<string[]>([]);

        const requiredFieldsRef = useRef<string[]>(defaultRequiredFields);
        const getUserId = () => formDetails?.UserId?.[0] ?? "";
        useEffect(() => {
            if (formAlternateData !== null) {
                setFormDetails({
                    ...{
                        FirstName: "",
                        LastName: "",
                        PhoneNumber: "",
                        Extension: "",
                        AlternatePhoneNumber: "",
                        AlternateExtension: "",
                        Email: "",
                        phNumCountryCode: [""],
                        countryName: [""],
                        phNumAlternateCountryCode: [""],
                        alternateaddsavedcontacts: "false",
                        UserId: [" "],
                        countryId: [""],
                        cpf: "",
                        neighbourhood: "",
                        stateInscription: "",
                    },

                    UserId: [""],
                });
            }
        }, []);
        useEffect(() => {
            if (countryCodes != undefined && countryList != undefined) {
                setFilteredCountryCodeList(countryCodes);
                setFilteredAltCountryCodeList(countryCodes);
                setFilteredCountryList(countryList);
                setFormDetails(formAlternateData)

            }
            if (savedContactsDropDown?.length) {
                let savedContacts: any = [
                    { label: t('HPI.Dropdown.SelectSavedContact', { defaultValue: 'create a new contact' }), value: "-1" },
                    ...savedContactsDropDown
                ];
                setFilteredAltContacts(savedContacts);
            }
        }, [savedContactsDropDown, countryCodes, countryList]);

        useEffect(() => {
             const userId = getUserId()
            if (formDetails && !clear && userId && userId.length > 0) {
                const userId = getUserId();
                const isDisabled = userId !== "-1";
                setIsDisabled(isDisabled);
            }
            if (userId === "" || userId === undefined) {
              setIsDisabled(true);
            }
        }, [formDetails]);


        // useEffect(() => {

        // }, [savedContactsDropDown| countryCodes | countryList])



        useEffect(() => {
            if (formTouched) {
                const isValid = true;
                dispatch(setFormAlternateValidity({
                    isValid,
                    formData: formDetails
                }));
            }

        }, [formDetails]);
        useEffect(() => {
            setflgBrazil({
                neighbourhood: (formDetails?.neighbourhood === "") ? false : true,
                stateInscription: (formDetails?.stateInscription === "") ? false : true,
                cpf: (formDetails?.cpf === "") ? false : true,
            });
        }, []);

        useImperativeHandle(ref, () => ({
            submitForm: () => {
                if (formDetails.AlternatePhoneNumber?.length > 0) {
                    const specialCountryId = "a2ec3ba9-f09c-e611-80f0-3863bb2e4470";
                    requiredFieldsRef.current = formDetails?.countryId?.[0] === specialCountryId
                        ? [...defaultRequiredFields, 'AlternatePhoneNumber', "neighbourhood", "stateInscription", "cpf"]
                        : [...defaultRequiredFields, 'AlternatePhoneNumber'];
                } else {
                    requiredFieldsRef.current = requiredFieldsRef.current.filter(
                        (field) => field !== 'AlternatePhoneNumber'
                    );
                }
                const isValid = validateForm(formDetails);
                if (isValid) {
                    dispatch(setFormAlternateValidity({ isValid, formData: formDetails }));
                }
                return isValid;
            }
        }));

        // useEffect(() => {
        //     if (formDetails?.UserId[0] === '-1') {
        //         setIsDisabled(false);
        //         setDefaultRequiredFields(requiredFields);
        //         requiredFieldsRef.current = requiredFields
        //     } else {
        //         setIsDisabled(true);
        //         setDefaultRequiredFields([]);
        //         requiredFieldsRef.current = []
        //     }
        // }, []);

        const validateForm = (formDetails: AlternateContactInformation) => {
            let formIsValid = true;
            let firstErrorField: string | null = null;
            const userId = formDetails?.UserId?.[0] ?? "";
           
            for (const key in formDetails) {
                if (formDetails.hasOwnProperty(key)) {
                    const value = formDetails[key as keyof AlternateContactInformation];
                    const valueToValidate = Array.isArray(value) ? value.join(' ') : value;

                    // const keysWithValues = Object.keys(formDetails).filter(
                    //     key => {
                    //         const value = formDetails[key as keyof alternateFormDetails] || [];
                    //         return Array.isArray(value)
                    //             ? value.length > 0 && value[0] !== ''
                    //             : value.length > 0;
                    //     }
                    // );

                    const error = validateFields(key, valueToValidate, requiredFieldsRef.current, t);
                    if (error) {
                        setErrors((prevState) => ({
                            ...prevState,
                            [key]: error,
                        }));
                        formIsValid = false;
                        if (!firstErrorField) {
                            firstErrorField = key;
                        }
                    } else {
                        if (Array.isArray(formDetails[key as keyof AlternateContactInformation])) {
                            setErrors((prevState) => ({
                                ...prevState,
                                [key]: [''],
                            }));
                        } else {
                            setErrors((prevState) => ({
                                ...prevState,
                                [key]: '',
                            }));
                        }
                    }
                }
            }
            if (!formIsValid && firstErrorField) {
                scrollToErrorField(firstErrorField)
            }

            return formIsValid;
        };

        const fetchContactInfo = useCallback(async (payload: any) => {
            try {
                const data = await fetchContactDetails(dispatch, payload);
                setflgBrazil({
                    neighbourhood: (data?.neighbourhood === "") ? false : true,
                    stateInscription: (data?.stateInscription === "") ? false : true,
                    cpf: (data?.cpf === "") ? false : true,
                });
                setFormDetails((prevData) => ({ ...prevData, ...data }));
            } catch (err) {
                // setError("Failed to load contact details");
            }
        }, []);


        const selectSavedClearHandler = () => {
            setClear(true)
            setIsDisabled(true);
            setDefaultRequiredFields([]);
            setFormDetails({ ...alternateContactInformation });
            setDefaultRequiredFields([]);
            requiredFieldsRef.current = []
        }

        const popupHeader = () => {
            return (
                <p className="popup-header">
                    <img
                        src="https://logos-world.net/wp-content/uploads/2020/11/HP-Logo.png"
                        alt=""
                        style={{ height: "46px", width: "auto" }}
                    />
                    <span>{popupTilte}</span>
                </p>
            );
        };

        const handleCallBack = (title: string) => {
            setPopupTitle(title);
            setOpen(true);
        }

        const onSelectChangeHandler = (selectedOption: any, k: any) => {
            setFormTouched(true);
            setflgBrazil({
                neighbourhood: false,
                stateInscription: false,
                cpf: false
            });
            setErrors(alternateContactInformation);
            setClear(false)

            if (selectedOption?.value !== '-1') {
                setFormDetails((prevData) => ({ ...prevData, [k]: [selectedOption?.value] }));
                if (k === "countryId") {
                    let countryName = countryList.find((item: any) => item.value === selectedOption?.value);
                    setFormDetails((prevData) => ({ ...prevData, ["countryName"]: [countryName?.label] }));
                }
            } else {
                setIsDisabled(true);
                setFormDetails({ ...alternateContactInformation });
                setFormDetails((prevData) => ({ ...prevData, [k]: ['-1'] }));
            }

            if (k === 'UserId' && selectedOption.value !== '-1') {
                setDefaultRequiredFields([])
                setIsDisabled(true);
                const payload = {
                    contactid: selectedOption.value,


                };
                fetchContactInfo(payload);
            } else {
                setIsDisabled(false);
                setDefaultRequiredFields(requiredFields);
                requiredFieldsRef.current = requiredFields
            }

            validateField(k, selectedOption?.value)
        }


        const handleInputChange = useCallback((v: any, event: React.ChangeEvent<HTMLInputElement>) => {
            if (!formTouched) setFormTouched(true);
            const { name, value } = event.target;
            setFormDetails((prevData) => ({ ...prevData, [name]: v }));

            if (name !== 'PhoneNumber' && name !== 'Email' && name !== 'AlternatePhoneNumber') {
                validateField(name, v);
            } else {
                setErrors((prevState) => ({
                    ...prevState,
                    [name]: '',
                }));
            }

        }, [formTouched]);


        const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            const { name, value } = e.target;
            if (value) {
                validateField(name, value);
            }
        };


        const validateField = (name: string, value: string) => {
            let error = "";


            if (!value) {
                error = t('HPI.ErrorMessage.RequiredFields', { defaultValue: 'This field is required.' });
            }
            // if (name === "FirstName" && value && isValidField(value)) {
            //     error = t('HPI.ErrorMessage.InvalidFirstName',{defaultValue:'Invalid First Name'});
            // }

            // if (name === "LastName" && value && isValidField(value)) {
            //     error = "Invalid Last Name";
            // }

            if (
                name === "Email" && value && !isValidEmail(value)) {
                error = t('HPI.ErrorMessage.InvalidEmailFormat', { defaultValue: 'Invalid email format' });
            }

            if ((name === "PhoneNumber" || name === "AlternatePhoneNumber") && !isValidPhoneNumber(value)) {
                error = t('HPI.ErrorMessage.InvalidNumber', { defaultValue: 'Phone number must be 8-15 digits long and contain only numbers.' });
            }

            setErrors((prevState) => ({
                ...prevState,
                [name]: error,
            }));
        };

        const clearSelectHandler = (field: any) => {
            setFormDetails((prevData) => ({ ...prevData, [field]: [''] }));
            //validateField(field, '')
        }

        const onAddsavedcontactsHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
            const { name, checked } = e.target;
            setFormDetails((prevData) => ({ ...prevData, ['alternateaddsavedcontacts']: checked ? 'true' : 'false' }));
        }

        useEffect(() => {
            const specialCountryId = "a2ec3ba9-f09c-e611-80f0-3863bb2e4470";
            requiredFieldsRef.current = formDetails?.countryId?.[0] === specialCountryId
                ? [...defaultRequiredFields, "neighbourhood", "stateInscription", "cpf"]
                : defaultRequiredFields;
        }, [formDetails?.countryId?.[0]]);

        return (
            <>
                {headerTitle ? <div className="">
                    <h4>{headerTitle}</h4>
                    <p>{headerContent}</p>
                    <p className="label-small" id="RequiredFields">
                        Required Fields <span className="text-danger">*</span>{" "}
                    </p>
                </div> : ''}

                <Row className="">

                    {<Col md={6}>
                        <Select
                            options={filteredAltContacts || []}
                            label={`${t("HPI.CreateCase.Contactinformation.savedContact", { defaultValue: 'Saved Contact -' })} ${t("HPI.CreateCase.Contactinformation.choosefromlist", { defaultValue: 'Choose a saved contact or create a new contact' })}`}
                            helperTextVisibility="auto"
                            separateLabel
                            name="UserId"
                            onChange={(selectedOption: any) => onSelectChangeHandler(selectedOption, 'UserId')}
                            value={formDetails?.UserId}
                            placeholder={t('HPI.Dropdown.DefaultText', { defaultValue: 'Please select' })}
                            onSearch={(value: any) => {
                                // let filter: any = onSearchDropDown(Contactdrop, value);
                                // setSaveContact(filter);
                            }}
                            className="textbox"

                            onClear={() => {
                                selectSavedClearHandler()
                            }}
                            {...getFieldError(errors, "UserId")}
                        />
                    </Col>}

                </Row>

                <Row>
                    <Col md={6}>
                        <TextBox
                            separateLabel
                            required
                            label={t("HPI.CreateCase.Contactinformation.Firstname", { defaultValue: 'First Name' })}
                            disabled={isDisabled}
                            name="FirstName"
                            placeholder={t('HPI.Profilepage.Placeholder.EnterFirstName', { defaultValue: 'Enter first name' })}
                            onChange={(v: any, e) => handleInputChange(v, e)}
                            value={formDetails.FirstName}
                            error={!!errors.FirstName}
                            helperText={errors.FirstName}
                            className="textbox"
                        />
                    </Col>

                    <Col md={6}>
                        <TextBox
                            separateLabel
                            required
                            label={t("HPI.CreateCase.Contactinformation.Lastname", { defaultValue: 'Last Name' })}
                            disabled={isDisabled}
                            name="LastName"
                            placeholder={t('HPI.Profilepage.Placeholder.EnterLastName', { defaultValue: 'Enter last name' })}
                            onChange={(v: any, e) => handleInputChange(v, e)}
                            value={formDetails.LastName}
                            error={!!errors.LastName}
                            helperText={errors.LastName}
                            className="textbox"
                        />
                    </Col>




                    <Col lg={2} md={6}>
                        <Select
                            separateLabel
                            required
                            options={filteredCountryCodeList}
                            disabled={isDisabled}
                            showSearch
                            name="countryId"
                            label={t('HPI.ProfilePage.cs.SelectCountryCode', { defaultValue: 'Code' })}
                            placement="bottom"
                            placeholder={t('HPI.ProfilePage.cs.SelectCountryCode', { defaultValue: 'Code' })}
                            value={formDetails.countryId || []}
                            helperTextVisibility="auto"
                            onClear={() => { clearSelectHandler('countryId') }}
                            onSearch={(value: any) => {
                                let filtered: any = onSearchDropDown(countryCodes, value);
                                setFilteredCountryCodeList(filtered);
                            }}
                            onChange={(selectedOption: any) => onSelectChangeHandler(selectedOption, 'countryId')}
                            {...getFieldError(errors, "countryId")}
                            className="textbox country-code"
                        />


                    </Col>
                    <Col lg={4} md={6}>
                        <label className="custom-label">{t("HPI.CreateCase.Contactinformation.Phonenumber", { defaultValue: 'Phone Number' })}
                            {!isDisabled && <span className="error">*</span>}
                        </label>
                        <span className="supporting-text">
                            <HelpModalPopup
                                align={"start"}
                                id={"modal-popup"}

                                show={open}
                                onClose={() => setOpen(false)}
                                title={popupHeader()}
                                callback={() => handleCallBack(t('HPI.CreateCase.Contactinformation.Phonenumber', { defaultValue: 'Phone Number' }))}
                            >
                                <p>
                                    {t('HPI.Profilepage.PhoneNumberToolTip.body', { defaultValue: `Please enter no more than 15 numerals, starting with country code (do not use '+' or any other characters)` })}

                                </p>
                            </HelpModalPopup>
                        </span>
                        <TextBox
                            placeholder={t('HPI.CreateCase.Placeholder.EnterPhoneNumber', { defaultValue: 'Enter phone number' })}
                            separateLabel
                            disabled={isDisabled}

                            //label={t("HPI.CreateCase.Contactinformation.Phonenumber",{ defaultValue: 'Phone Number' })}
                            value={formDetails.PhoneNumber}
                            name="PhoneNumber"
                            // onChange={(v: any, e) => handleInputChange(v, e)}
                            onChange={(v: any, e) => {
                                const value = getValidatedNumberInput(v, 15);
                                if (value.length <= 15) {
                                    handleInputChange(value, e);
                                }
                            }}
                            onBlur={(e) => handleBlur(e)}
                            error={!!errors.PhoneNumber}
                            helperText={errors.PhoneNumber}
                            className="textbox"
                        />

                    </Col>

                    <Col md={6}>
                        <TextBox
                            value={formDetails.Extension}
                            label={t("HPI.CreateCase.Contactinformation.Extension", { defaultValue: 'Extension' })}
                            name="Extension"
                            placeholder={t('HPI.CreateCase.Placeholder.EnterExtension', { defaultValue: 'Enter extension' })}
                            separateLabel
                            disabled={isDisabled}
                            className="textbox"
                            onChange={(v: any, e) => {
                                const value = getValidatedNumberInput(v, 5);
                                if (value.length <= 5) {
                                    handleInputChange(value, e);
                                }
                            }}

                        /></Col>

                    <Col lg={2} md={6}>
                        <Select
                            separateLabel
                            className="textbox country-code"
                            options={filteredAltCountryCodeList}
                            showSearch
                            disabled={isDisabled}
                            name="phNumAlternateCountryCode"
                            label={t('HPI.ProfilePage.cs.SelectCountryCode', { defaultValue: 'Code' })}
                            placement="bottom"
                            placeholder={t('HPI.ProfilePage.cs.SelectCountryCode', { defaultValue: 'Code' })}
                            value={formDetails.phNumAlternateCountryCode || []}
                            helperTextVisibility="auto"
                            onClear={() => { clearSelectHandler('phNumAlternateCountryCode') }}
                            onChange={(selectedOption: any) => onSelectChangeHandler(selectedOption, 'phNumAlternateCountryCode')}
                            {...getFieldError(errors, "phNumAlternateCountryCode")}
                            onSearch={(value: any) => {
                                let filtered: any = onSearchDropDown(countryCodes, value);
                                setFilteredAltCountryCodeList(filtered);
                            }}
                        />


                    </Col>
                    <Col lg={4} md={6} >
                        <label className="label-contact">{t("HPI.CreateCase.contactinformation.alternatehelpdesk", { defaultValue: 'Alternate Phone Number' })}

                        </label>
                        <span className="supporting-text" style={{ top: '-6px' }}>
                            <HelpModalPopup
                                align={"start"}
                                id={"modal-popup"}
                                show={open}
                                onClose={() => setOpen(false)}
                                title={popupHeader()}
                                callback={() => handleCallBack(t('HPI.CreateCase.Contactinformation.Phonenumber', { defaultValue: 'Phone Number' }))}
                            >
                                <p>
                                    {t('HPI.Profilepage.PhoneNumberToolTip.body', { defaultValue: `Please enter no more than 15 numerals, starting with country code (do not use '+' or any other characters)` })}

                                </p>
                            </HelpModalPopup>
                        </span>
                        <TextBox
                            placeholder={t('HPI.Profilepage.Placeholder.EnterAlternatePhoneNumber', { defaultValue: 'Enter alternate phone number' })}
                            separateLabel
                            disabled={isDisabled}
                            // label={t("HPI.CreateCase.contactinformation.alternatehelpdesk",{ defaultValue: 'Alternate Phone Number' })}
                            value={formDetails.AlternatePhoneNumber}
                            name="AlternatePhoneNumber"
                            onChange={(v: any, e) => {
                                const value = getValidatedNumberInput(v, 15);
                                if (value.length <= 15) {
                                    handleInputChange(value, e);
                                }
                            }}
                            onBlur={(e) => handleBlur(e)}
                            error={!!errors.AlternatePhoneNumber}
                            helperText={errors.AlternatePhoneNumber}
                            className="textbox"
                        />

                    </Col>

                    <Col md={6}>
                        <TextBox
                            value={formDetails.AlternateExtension}
                            label={t("HPI.CreateCase.Contactinformation.Extension", { defaultValue: 'Extension' })}
                            disabled={isDisabled}
                            name="AlternateExtension"
                            placeholder={t('HPI.CreateCase.Placeholder.EnterExtension', { defaultValue: 'Enter extension' })}
                            separateLabel
                            className="textbox"
                            onChange={(v: any, e) => {
                                const value = getValidatedNumberInput(v, 5);
                                if (value.length <= 5) {
                                    handleInputChange(value, e);
                                }
                            }}
                        /></Col>

                    <Col md={6}>
                        <Select
                            required
                            showSearch
                            placement="bottom"
                            options={filteredCountryList}
                            label={t("HPI.CreateCase.address.CountryRegion", { defaultValue: 'Country/Region' })}
                            helperTextVisibility="auto"
                            separateLabel
                            disabled={isDisabled}
                            name="countryId"
                            onChange={(selectedOption: any) =>
                                onSelectChangeHandler(selectedOption, "countryId")
                            }
                            value={formDetails?.countryId || []}
                            placeholder={t('HPI.Dropdown.DefaultText', { defaultValue: 'Please select' })}
                            onSearch={(value: any) => {
                                let filtered: any = onSearchDropDown(countryList, value);
                                setFilteredCountryList(filtered);
                            }}
                            onClear={() => {
                                clearSelectHandler("countryId");
                            }}
                            {...getFieldError(errors, "countryId")}
                            className="textbox"
                        />
                    </Col>
                    <Col md={6}>
                        <TextBox
                            separateLabel
                            required
                            label={t("HPI.CreateCase.Contactinformation.Email", { defaultValue: 'Email' })}
                            type="email"
                            disabled={isDisabled}
                            name="Email"
                            placeholder={t('HPI.CreateCase.Placeholder.EnterEmail', { defaultValue: 'Enter email' })}
                            value={formDetails.Email}
                            onChange={(v: any, e) => handleInputChange(v, e)}
                            onBlur={(e) => handleBlur(e)}
                            error={!!errors.Email}
                            helperText={errors.Email}
                            className="textbox"
                        />
                    </Col>

                </Row>

                {(formDetails?.countryId || []).includes(
                    "a2ec3ba9-f09c-e611-80f0-3863bb2e4470"
                ) && (
                        <>
                            <Row>
                                <Col md={6}>
                                    <TextBox
                                        separateLabel
                                        label={t("HPI.CreateCase.Contactinformation.Neighborhood", { defaultValue: 'Neighborhood' })}
                                        required
                                        disabled={flgBrazil.neighbourhood}
                                        name="neighbourhood"
                                        placeholder={t('HPI.CreateCase.Placeholder.EnterNeighborhood', { defaultValue: 'Enter neighborhood' })}
                                        onChange={(v: any, e) => handleInputChange(v, e)}
                                        value={formDetails.neighbourhood}
                                        error={!!errors.neighbourhood}
                                        helperText={errors.neighbourhood}
                                        className="textbox"
                                    />
                                </Col>

                                <Col md={6}>
                                    <TextBox
                                        separateLabel
                                        required
                                        label={t("HPI.CreateCase.Contactinformation.CPF_CNPJ", { defaultValue: 'CPF CNPJ' })}
                                        name="cpf"
                                        disabled={flgBrazil.cpf}
                                        placeholder={t('HPI.CreateCase.Placeholder.EnterCPF/CNPJ', { defaultValue: 'Enter CPF/CNPJ' })}
                                        // disabled={isDisabledFeild(formDetails.cpf)}
                                        onChange={(v: any, e) => handleInputChange(v, e)}
                                        value={formDetails.cpf}
                                        error={!!errors.cpf}
                                        helperText={errors.cpf}
                                        className="textbox"
                                    />
                                </Col>
                            </Row>

                            <Row>
                                <Col md={6}>
                                    <TextBox
                                        separateLabel
                                        label={t("HPI.CreateCase.Contactinformation.State_Inscription", { defaultValue: 'State Inscription' })}
                                        required
                                        disabled={flgBrazil.stateInscription}
                                        name="stateInscription"
                                        // disabled={isDisabledFeild(formDetails.stateInscription)}
                                        placeholder={t('HPI.CreateCase.Placeholder.EnterStateInscription', { defaultValue: 'Enter state inscription' })}
                                        onChange={(v: any, e) => handleInputChange(v, e)}
                                        value={formDetails.stateInscription}
                                        error={!!errors.stateInscription}
                                        helperText={errors.stateInscription}
                                        className="textbox"
                                    />
                                </Col>
                            </Row>
                        </>
                    )}

                {!isDisabled &&
                    <div className="row">
                        <div className="col-md-12 checkbox-container">
                            <div>
                                <Checkbox
                                    name={formDetails.alternateaddsavedcontacts}
                                    onChange={onAddsavedcontactsHandler}
                                    label={t("HPI.CreateCase.Contactinformation.addthiscontactheading", { defaultValue: 'Add this contact to my saved contacts' })}
                                />
                            </div>
                        </div>
                    </div>}

            </>
        );
    });

export default React.memo(CaseAlternateAddress);